var _g, _circle;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLocalization = function SvgLocalization(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.752,
    height: 25.758,
    viewBox: "0 0 24.752 28.758",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7848",
    "data-name": "Grupo 7848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subtra\\xE7\\xE3o_6",
    "data-name": "Subtra\\xE7\\xE3o 6",
    transform: "translate(-10999 1432.648)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11009.376-1432.648a10.578,10.578,0,0,1,10.376,10.769c0,5.947-10.266,15.046-10.376,14.989,0-.021-10.376-9.042-10.376-14.989A10.578,10.578,0,0,1,11009.376-1432.648Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11009.3759765625 -1430.1484375 C 11005.033203125 -1430.1484375 11001.5 -1426.439208984375 11001.5 -1421.8798828125 C 11001.5 -1421.088745117188 11001.9052734375 -1418.766235351563 11005.6552734375 -1414.2958984375 C 11006.7509765625 -1412.990478515625 11008.0498046875 -1411.604248046875 11009.4169921875 -1410.276489257813 C 11010.3974609375 -1411.220703125 11011.740234375 -1412.59521484375 11013.0830078125 -1414.20556640625 C 11016.845703125 -1418.717163085938 11017.251953125 -1421.075439453125 11017.251953125 -1421.8798828125 C 11017.251953125 -1426.439208984375 11013.71875 -1430.1484375 11009.3759765625 -1430.1484375 M 11009.3759765625 -1432.6484375 C 11015.1064453125 -1432.6484375 11019.751953125 -1427.8271484375 11019.751953125 -1421.8798828125 C 11019.751953125 -1415.951049804688 11009.5498046875 -1406.890502929688 11009.376953125 -1406.890502929688 C 11009.376953125 -1406.890502929688 11009.3759765625 -1406.890625 11009.3759765625 -1406.890747070313 C 11009.3779296875 -1406.911254882813 10999 -1415.932495117188 10999 -1421.8798828125 C 10999 -1427.8271484375 11003.6455078125 -1432.6484375 11009.3759765625 -1432.6484375 Z",
    stroke: "none",
    fill: "#002063"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_376",
    "data-name": "Elipse 376",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(7.376 7.352)",
    fill: "#002063"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocalization, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/localization.ddc6868b.svg";
export { ForwardRef as ReactComponent };